import * as React from 'react';

import { Icon } from 'antd';
import { getLogoName } from '../../../../utils/config';

import ButtonLogin from '../ButtonLogin';
import InputLogin from '../InputLogin';

import './LoginForm.less';

interface Props {
  error: string;
  loading: boolean;
  onSubmit: (login: string, password: string) => void;
}

class LoginForm extends React.PureComponent<Props> {
  static defaultProps = {
    error: 'dfd',
  };

  state = {
    login: '',
    password: '',
  };

  handleChange = (name: string, value: string) => {
    this.setState({
      [name]: value,
    });
  };

  handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const { password, login } = this.state;
    this.props.onSubmit(login.trim(), password.trim());
  };

  render() {
    const { error, loading } = this.props;
    const { login, password } = this.state;
    const logoName = getLogoName();
    const logoSvg = require(`../../../../assets/${logoName}`);
    return (
      <div className="login-form-panel">
        <div className="login-form-panel__content">
          <form className="login-form" onSubmit={this.handleSubmit}>
            <div className="header__logo">
              <span>
                <img src={logoSvg} alt="Logo" />
              </span>
            </div>
            <div className="login-form__login">
              <InputLogin
                value={login}
                name={'login'}
                onChange={this.handleChange}
                prefix={
                  <Icon
                    type="user"
                    style={{ color: '#555', paddingLeft: '10px' }}
                  />
                }
                placeholder="Имя пользователя"
              />
            </div>
            <div className="login-form__password">
              <InputLogin
                value={password}
                name={'password'}
                type="password"
                onChange={this.handleChange}
                prefix={
                  <Icon
                    type="lock"
                    style={{ color: '#555', paddingLeft: '10px' }}
                  />
                }
                placeholder="Пароль"
              />
            </div>
            {error && <div className="login-form__error">{error}</div>}
            <div className="login-form__submit">
              <ButtonLogin loading={loading}>Войти</ButtonLogin>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default LoginForm;



// WEBPACK FOOTER //
// ./src/scenes/Login/components/LoginForm/LoginForm.tsx